import "./userCard.css"
import {editUserTeam} from "../../services/teamService.js"
import {deleteUser} from "../../services/userServices.js"

export default function UserCard ({user, inTeam, refreshTeam, refreshUser}){
    const handleDeleteUserTeam = async() => {
        await editUserTeam(null, user.id)
        refreshTeam()
    }

    const handleDeleteUser = async () => {
        await deleteUser(user.id)
    }

    return(
        <>
            {
                inTeam ? (
                    <div className="row">
                        <span className="name">{user?.name_user}</span>
                        <span className="email">{user?.email_user}</span>
                        <span className="rol">{user?.rol_user}</span>
                        <span className="rol">{user?.phone_number_user}</span>
                        <button onClick={handleDeleteUserTeam}>Eliminar del grupo</button>   
                    </div>                   
                ) : (
                    <form className="row">
                        <span className="name">{user?.name_user}</span>
                        <span className="email">{user?.email_user}</span>
                        <span className="rol">{user?.rol_user}</span>
                        <span className="rol">{user?.phone_number_user}</span>
                        <span className="team">{user?.name}</span>
                        <button onClick={handleDeleteUser}>Eliminar usuario</button>   
                    </form>   
                )            
            }
                      
        </>
    )
}